<template>
  <div class="list">
    <div class="item" v-for="(item, index) in list" :key="index">
      <div class="item-title">{{ item.alpha }}</div>
      <div class="item-list">
        <div
          class="item-i-content"
          v-for="(item1, index1) in item.subItems"
          :key="index1"
          @click="bindClick(item1)"
        >
          <div class="name">{{ item1.name }}</div>
          <div class="code">{{ item1.code }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {}
  },
  methods: {
    bindClick(item) {
      this.$emit('choose', item.code)
    }
  }
}
</script>
<style lang="scss" scoped>
.list {
  .item {
    .item-title {
      height: 32px;
      line-height: 32px;
      background: #f7f7f7;
      padding: 0px 20px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.3);
    }

    .item-list {
      .item-i-content {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 15px 50px 15px 20px;
        font-size: 15px;

        .name {
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          color: #000000;
          line-height: 20px;
        }

        .code {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: rgba(0, 0, 0, 0.5);
          line-height: 20px;
        }
      }
    }
  }
}
</style>
